/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskGreatDataScan } from './ExecRiskGreatDataScan';
import {
    ExecRiskGreatDataScanFromJSON,
    ExecRiskGreatDataScanFromJSONTyped,
    ExecRiskGreatDataScanToJSON,
} from './ExecRiskGreatDataScan';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedGreatDataResponse
 */
export interface ExecRiskPaginatedGreatDataResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedGreatDataResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskGreatDataScan>}
     * @memberof ExecRiskPaginatedGreatDataResponse
     */
    results: Array<ExecRiskGreatDataScan>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedGreatDataResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedGreatDataResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedGreatDataResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedGreatDataResponse interface.
 */
export function instanceOfExecRiskPaginatedGreatDataResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedGreatDataResponseFromJSON(json: any): ExecRiskPaginatedGreatDataResponse {
    return ExecRiskPaginatedGreatDataResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedGreatDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedGreatDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskGreatDataScanFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedGreatDataResponseToJSON(value?: ExecRiskPaginatedGreatDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskGreatDataScanToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

